import React, { useEffect, useState } from "react";
import binanceLogo from "../../images/binanceLogo.png";
import bitfinexLogo from "../../images/bitfinexLogo.png";
import bitmexLogo from "../../images/bitmexLogo.png";
import okxLogo from "../../images/okxLogo.png";
import bybitLogo from "../../images/bybitLogo.png";
import dollarIco from "../../images/dollarIco.png";
import api from "../../api";
import { Loader } from "../global/loader";
import { useMediaQuery } from "react-responsive";

const coinList = [
  {
    timeframe: "1h",
  },
  {
    timeframe: "4h",
  },
];

export const LiquidityLens = () => {
  const [selectedTime, setSelectedTime] = useState("4h");
  const [LiquidationData, setLiquidationData] = useState([]);
  const [loader, setLoader] = useState(true);
  const baseUrl = `${window.location.protocol}//${window.location.host}`;

  const getMarketLiquidity = async () => {
    try {
      let payload = {
        timeframe: selectedTime,
      };
      setLoader(true);
      const resp = await api.getliquidityLens(payload);
      // console.log(resp);
      if (resp?.data) {
        setLiquidationData(resp?.data);
      }
      setLoader(false);
    } catch (e) {
      console.log(e.message);
      setLoader(false);
    }
  };

  useEffect(() => {
    getMarketLiquidity();
  }, [selectedTime]);

  return (
    <div className="liquidityMain">
      <div className="selectCoin">
        <h5 className="me-2">Liquidity Lens</h5>

        <div className="expand">
          <button
            className=" dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {selectedTime}
          </button>
          <ul className="dropdown-menu">
            <div className="coinSelector">
              {coinList.map((item, key) => (
                <div
                  className="coin"
                  onClick={() => setSelectedTime(item.timeframe)}
                  key={key}
                >
                  <div className="name">{item.timeframe}</div>
                </div>
              ))}
            </div>
          </ul>
        </div>
      </div>
      <div className="descrip mb-2">
        Advanced liquidity analysis showing inflow, outflow, and netflow for
        major cryptocurrencies across different timeframes.
      </div>
      <Table data={LiquidationData || []} />

      {loader && <Loader />}
    </div>
  );
};

const Table = ({ data }) => {
  function formatNumber(num) {
    const isNegative = num < 0;
    const absNum = Math.abs(num);

    let formatted;
    if (absNum >= 1_000_000_000) {
      formatted = (absNum / 1_000_000_000).toFixed(1).replace(/\.0$/, "") + "B";
    } else if (absNum >= 1_000_000) {
      formatted = (absNum / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M";
    } else if (absNum >= 1_000) {
      formatted = (absNum / 1_000).toFixed(1).replace(/\.0$/, "") + "K";
    } else {
      formatted = absNum.toString();
    }

    return isNegative ? `-${formatted}` : formatted;
  }
  const isLarge = useMediaQuery({
    query: "(min-width: 576px)",
  });
  return (
    <>
      <div className="card sortby-box br-10 border-transparent mt-3">
        <div className="card-header br-10  bg-white border-transparent pt-0 px-0 ">
          <div className="table-responsive">
            <table className="table table-hover drivers-table">
              <thead>
                <tr>
                  {isLarge && (
                    <th scope="col" className="">
                      #
                    </th>
                  )}
                  <th scope="col" className="sticky-col-head">
                    Name
                  </th>
                  <th scope="col" className="">
                    <div className="color-green w-max">
                      <i className="fa-solid fa-circle-arrow-up me-2"></i>
                      InFlow
                    </div>
                  </th>
                  <th scope="col" className="">
                    <div className="color-red w-max">
                      <i className="fa-solid fa-circle-arrow-down me-2"></i>
                      OutFlow
                    </div>
                  </th>
                  <th scope="col" className="">
                    NetFlow
                  </th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, key) => (
                  <tr key={key}>
                    {isLarge && (
                      <td scope="row">
                        <div className="table-text-dark w-max-c db">
                          {key + 1}
                        </div>
                      </td>
                    )}
                    <td scope="row" className="sticky-col">
                      <div className="table-text-dark w-max-c db">
                        {item?.symbol}
                      </div>
                    </td>
                    <td scope="row">
                      <div className=" w-max-c db color-green">
                        ${formatNumber(item?.inflow || 0)}
                      </div>
                    </td>
                    <td scope="row">
                      <div className="w-max-c db color-red">
                        ${formatNumber(item?.outflow || 0)}
                      </div>
                    </td>
                    <td scope="row">
                      <div className="table-text-dark w-max-c db">
                        ${formatNumber(item?.netflow || 0)}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};
